import ProgressBarComponent from './containers/progressBarComponent'

export { default as ProgressBarComponentLayout } from './components/progressBarComponentLayout'

export default ProgressBarComponent
